import { REAGION_SOATO } from '@/common/constants/regions';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';
import { FC, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { useMonitoringStore } from '../../../store/useMonitoringStore';
import { NavigateTitle } from '../../navigate-title/NavigateTitle';
import { TableMonitoringLoading } from '../TableLoading';
import { TableDistrict } from './table/TableDistrict';
import { exportMonitoringDistrictToExcel } from '../../../utils/exportMonitoringDistrictToExcel';

export const MonitoringDistrict: FC = () => {
  const [searchParams] = useSearchParams();
  const plant_id = searchParams.get('plant_id');
  const year = searchParams.get('year');
  const { region_id } = useParams();
  const { t } = useTranslation();
  const {
    dataDistrict,
    dataDistrictCachedAt,
    districtLoading,
    cottonDistrictData,
    cottonDistrictLoading,
    fetchMonitoringDistrict,
    fetchCottonDistrict,
  } = useMonitoringStore();
  useEffect(() => {
    if (region_id) {
      if (plant_id && year) {
        fetchMonitoringDistrict({ region_id, year, plant_id });
      }
      fetchCottonDistrict({
        region_id: REAGION_SOATO.find((item) => item.id === String(region_id))
          ?.soato,
        year: year || '',
        plant_id: plant_id || '',
      });
    }
  }, [region_id, year, plant_id]);

  const handleExport = async () => {
    if (dataDistrict.length > 0) {
      const regionName = REAGION_SOATO.find((item) => item.id === String(region_id))?.name;
      await exportMonitoringDistrictToExcel(dataDistrict, cottonDistrictData, plant_id || '2', t, regionName);
    }
  };

  return (
    <div className="flex flex-col gap-4 p-8 h-full">
      <div className="flex-shrink-0">
        <div className="flex items-center justify-between">
          <div className="flex flex-col">
            <NavigateTitle regionId={region_id} />
            {dataDistrictCachedAt && (
              <p className="text-sm text-gray-500 font-medium">
                {t('data.actual.on', {
                  date: format(
                    new Date(dataDistrictCachedAt),
                    'yyyy-MM-dd HH:mm',
                  ),
                })}
              </p>
            )}
          </div>

          {dataDistrict.length > 0 && (
            <Button
              onClick={handleExport}
              className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white"
            >
              <Download className="size-4" />
              Excel
            </Button>
          )}
        </div>
      </div>
      {districtLoading || cottonDistrictLoading ? (
        <TableMonitoringLoading />
      ) : (
        <div className="flex-1 overflow-hidden">
          <TableDistrict
            dataDistrict={dataDistrict}
            cottonData={cottonDistrictData}
          />
        </div>
      )}
    </div>
  );
};
